import "./PrintSpecimenButton.css";
import PrintSpecimenButtonView from "./PrintSpecimenButtonView";
import { useBarcodePrintingCallbacks } from "../../../../../hooks/useBarcodePrintingCallbacks";

type OneOrMany<T> = T | T[];
type SpecimenIds = OneOrMany<number>;
export type PrintButtonVariant = "primary" | "secondary";
export type PrintSpecimenButtonProps = {
  specimenIds: SpecimenIds;
  specimenCaseId: number;
  children?: React.ReactNode;
  variant?: PrintButtonVariant;
};

export const PrintSpecimenButton = ({
  specimenIds: specimenIdsRaw,
  specimenCaseId,
  children,
  variant = "primary",
}: PrintSpecimenButtonProps) => {
  const { printSpecimen } = useBarcodePrintingCallbacks();

  // Normalize specimenId singleton or array to array
  const specimenIds = ([] as number[]).concat(specimenIdsRaw);

  // If No Specimen Ids, no Labels to print.  Return null.
  if (specimenIds.length === 0) return null;

  const buttonProps = {
    specimenIds,
    specimenCaseId,
    performPrintAction: () => printSpecimen(specimenIds, specimenCaseId),
    variant,
  };

  return (
    <PrintSpecimenButtonView {...buttonProps}>
      {children}
    </PrintSpecimenButtonView>
  );
};
export default PrintSpecimenButton;
